import { useDispatch, useSelector } from 'react-redux';
import { Modal, Checkbox } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import { MODAL_WHITELABEL_ACCEPT_TERMS_AND_CONDITIONS } from '../../../../reducers/Modal/types';
import { setModalState } from '../../../../reducers/Modal/actions';
import { ZorbaButton } from '../../../../components/forms';
import { acceptWhitelabelTermsAndConditions } from '../../../../reducers/Auth/actions';
import { WhitelabelTerms } from './WhitelabelTerms';
import './index.scss';

export const WhitelabelAcceptTermsAndConditionsModal = ({ fetchReport }) => {
  const dispatch = useDispatch();
  const [isRead, setIsRead] = useState(false);
  const { isWhitelabelAcceptTermsAndConditionsModalOpen } = useSelector(
    ({ ModalReducer }) => ModalReducer,
  );
  const { userDetails, isAppLoading, isAuthLoading } = useSelector(
    ({ AuthReducer }) => AuthReducer,
  );

  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsCheckboxChecked(event.target.checked);
  };

  useEffect(() => {
    if (
      !isAuthLoading &&
      !isAppLoading &&
      userDetails?.isCompletedOnboarding &&
      !userDetails?.defaultOrganization?.whiteLabelAdminTermsOfUse?.signedAt
    ) {
      dispatch(
        setModalState(MODAL_WHITELABEL_ACCEPT_TERMS_AND_CONDITIONS, true),
      );
    }
  }, [userDetails]);

  const containerRef = useRef();
  const handleScroll = useCallback(() => {
    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
    if (scrollTop + clientHeight - scrollHeight >= -1) {
      setIsRead(true);
    }
  }, [containerRef]);

  const handleClose = () => {
    dispatch(
      setModalState(MODAL_WHITELABEL_ACCEPT_TERMS_AND_CONDITIONS, false),
    );
  };

  const handleAcceptTermsAndConditions = () => {
    dispatch(acceptWhitelabelTermsAndConditions(handleClose));
    fetchReport();
  };

  return (
    <Modal
      open={isWhitelabelAcceptTermsAndConditionsModalOpen}
      footer={null}
      title="Terms and Conditions"
      destroyOnClose
      closable={false}
      className="terms-and-conditions-modal"
    >
      <WhitelabelTerms
        handleScroll={handleScroll}
        containerRef={containerRef}
        entityName={userDetails?.defaultOrganization?.entityName || ''}
      />
      <div className="checkbox-container">
        <Checkbox
          checked={isCheckboxChecked}
          onChange={handleCheckboxChange}
          disabled={!isRead}
        >
          I agree to these terms and conditions
        </Checkbox>
      </div>
      <div className="button-container">
        <ZorbaButton
          disabled={!isCheckboxChecked}
          onClick={handleAcceptTermsAndConditions}
        >
          Accept
        </ZorbaButton>
      </div>
    </Modal>
  );
};
